// src/modules/app-views/products/pages/Init/components/tableColumns/eanColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { BarcodeOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function eanColumn(buildColumnProps, options = {}) {
  const {
    key = 'ean',
    title = 'ean',
    dataIndex = 'ean',
    width = 150,
    columnProps = { sort: true, search: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const ean = r?.ean;
      return ean ? (
        <span>
          <BarcodeOutlined style={{ marginRight: 4, color: '#8c8c8c' }} />
          {ean}
        </span>
      ) : (
        '—'
      );
    },
  };
}

export default eanColumn;
